exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment[data-v-2a41e5fe]{height:46px;border-radius:5px}.pointer[data-v-2a41e5fe]{cursor:pointer}.card[data-v-2a41e5fe]{border-radius:0!important}.nav-link.active[data-v-2a41e5fe]{background-color:#fff!important}", ""]);

// exports
